import React from 'react';
import Section from "../../components/Section/Section";
import Accordion from "../../components/Accordion/Accordion";

function Questions() {
	return (
		<Section>
			<Accordion/>
		</Section>
	);
}

export default Questions;